import { render, staticRenderFns } from "./SubmissionEntityDataList.vue?vue&type=template&id=288b6008"
import script from "./SubmissionEntityDataList.vue?vue&type=script&lang=js"
export * from "./SubmissionEntityDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports